module.exports = __webpack_public_path__ + "img/maximize-mode.0f6b4f82.jpg";